import React from 'react';
import { Table, Modal } from '@roo/roo';
import dayjs from 'dayjs';
import { SignItem } from '../api';

interface IProps {
    visible: boolean;
    data: SignItem | null;
    onCancel: () => void;
}

export default class SupportModal extends React.Component<IProps> {
    columns = [
        {
            prop: 'contractName',
            label: '合同名称',
        },
        {
            prop: 'signTime',
            label: '签订日期',
            render: (text: number) => dayjs(text * 1000).format('YYYY-MM-DD'),
        },
        {
            prop: 'pdfUrl',
            label: '操作',
            render: (text: string) => (
                <a href={text} target="_blank" rel="noopener noreferrer">
                    查看
                </a>
            ),
        },
    ];

    render() {
        const { columns } = this;
        const { visible, onCancel, data } = this.props;
        let contractList: any = [];
        if (data && data.contractList) {
            contractList = data.contractList;
        }
        return (
            <Modal
                visible={visible}
                onCancel={onCancel}
                showCancelButton={false}
                showConfirmButton={false}
            >
                <Table
                    rowKey="contractName"
                    border
                    hover
                    columns={columns}
                    data={contractList || []}
                />
            </Modal>
        );
    }
}
